<template>
    <div class="footer-box">
        <div class="container social-box">
            <div class="row">
                <div class="col-3">
                    <img src="../../public/images/qrcode/t2.jpg" class="rounded figure-img img-fluid" alt="...">
                    <figcaption class="figure-caption">微信公众号</figcaption>
                </div>
                <div class="col-3">
                    <img src="../../public/images/qrcode/t3.jpg" class="rounded figure-img img-fluid" alt="...">
                    <figcaption class="figure-caption">小红书</figcaption>
                </div>
                <div class="col-3">
                    <img src="../../public/images/qrcode/t1.jpg" class="rounded figure-img img-fluid" alt="...">
                    <figcaption class="figure-caption">微信客服1</figcaption>
                </div>
                <div class="col-3">
                    <img src="../../public/images/qrcode/t4.png" class="rounded figure-img img-fluid" alt="...">
                    <figcaption class="figure-caption">微信客服2</figcaption>
                </div>
            </div>
        </div>
        <div class="cy-box">
            <p class="msg">扫码即刻关注“苏州葡旅葡萄酒进出口贸易有限公司”</p>

            Copyright © 2024 葡旅酒庄 版权所有 ®中国葡萄酒品牌
            <a href="https://beian.miit.gov.cn/" rel="nofollow">苏ICP备2024120650号</a>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>
.footer-box {
    height: 345px;
    background: #6a0b2d;
    font-size: 14px;
}

.social-box {
    height: 295px;
    padding-top: 80px;
    color: #fff;

    .figure-caption {
        color: #fff;
    }

    img{
        width: 120px;
    }
}

.cy-box {
    height: 100px;
    background: #590022;

    color: #fff;
    line-height: 30px;

    a {
        color: #fff;
    }

    .msg {
        padding-top: 20px;
    }
}
</style>